export function formatPrice(value) {
  const n = parseFloat(value);
  if (isNaN(n)) return '0';
  return Math.round(n).toLocaleString('es-CL');
}
